// src/components/Team/TeamSection.js
import React from 'react';
import styles from './TeamSection.module.css';
import TeamMember from './TeamMember';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Sanjeet',
      image: '/images/team/T01.png',
      linkedinUrl: 'https://www.linkedin.com/in/sanjeet-kumar-mahato'
    },
    {
      name: 'Siddharth',
      image: '/images/team/T02.png',
      linkedinUrl: 'https://www.linkedin.com/in/siddharth-sahoo99'
    },
    {
      name: 'Anurag',
      image: '/images/team/T03.png',
      linkedinUrl: 'https://www.linkedin.com/in/anuragxaxa'
    },
    {
      name: 'Sunil',
      image: '/images/team/T04.png',
      linkedinUrl: 'https://www.linkedin.com/in/sunil-kumar-khada-854371354/'
    },
    {
      name: 'Chhatrasal',
      image: '/images/team/T05.png',
      linkedinUrl: 'https://www.linkedin.com/in/chhatrasal'
    }
  ];

  const handleApplyClick = () => {
    const emailAddress = 'sanjeetm@teezash.com';
    const subject = 'Application Inquiry';
    const body = 'I am interested in applying for a position with your team.';
    
    window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section className={styles.teamSection} id="team">
      <div className={styles.teamContent}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>MEET OUR TEAM</h2>
          <p className={styles.description}>
            Meet the innovative minds behind Teezash's success. Our diverse team brings together expertise in IoT, 
            software development, and safety solutions to create cutting-edge technology that makes a difference.
          </p>
          <button 
            className={styles.applyButton}
            onClick={handleApplyClick}
            aria-label="Apply to join our team"
          >
            Apply Now
          </button>
        </div>
        
        <div className={styles.teamGrid}>
          {teamMembers.map((member, index) => (
            <TeamMember
              key={index}
              name={member.name}
              image={member.image}
              linkedinUrl={member.linkedinUrl}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;